import type { ApiStorageStockEntry } from '@Model';
import { groupStorageStock, type StockRow } from '../Stock/stockView';

/** How many AVVs are offered as buttons before the hint only asks for an AVV. */
export const MAX_AVV_BUTTONS = 3;

/** The AVVs under which the stock holds the material, none once an AVV is chosen. */
// @ai-generated 2026-10-27T12:00:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function avvSuggestions(
    entries: ApiStorageStockEntry[],
    materialId: string | undefined,
    avvId: string | undefined,
): StockRow[] {
    if (!materialId || avvId) {
        return [];
    }

    const withAvv = entries.filter((entry) => entry.material.foreign_key === materialId && entry.avv.foreign_key);
    return groupStorageStock(withAvv, 'avv').rows;
}
